export default {
  outbound: 'Afrejse',
  inbound: 'Retur',
  hide: 'Skjule',
  details: 'Detaljer',
}
